import { AnaDialogService } from '@anacapri/angular/dialog';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service capable of router to new routes.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class NavService {
	/**
	 * @param router the Angular Router
	 * @param dialogService the Anacapri dialog service
	 */
	constructor(
		private router: Router,
		private dialogService: AnaDialogService
	) {}

	/**
	 * Navigate to the track a claim page.
	 */
	toTrackAClaim = (): Promise<boolean> => {
		this.dialogService.closeAll();
		return this.router.navigate(['track-a-claim']);
	};

	/**
	 * Navigate to the maintenance page.
	 */
	toMaintenance = (): Promise<boolean> => {
		this.dialogService.closeAll();
		return this.router.navigate(['maintenance']);
	};
}
